export const PageFirst = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.6996 25.3648L15.402 15.9546L24.6661 6.63523" stroke="currentColor" stroke-width="2"/>
<path d="M9 4L9 28" stroke="currentColor" stroke-width="2"/>
</svg>`;
